export default "__VITE_ASSET__DbfeT8$w__"